import type { ElementType, ReactNode } from "react";
import { Button } from "antd";
import { APP_BUTTON_SIZE } from "../AppUi";

export const PageHeader = ({
  title,
  subText,
  handleButtons,
  searchBar,
}: {
  title: string;
  subText?: string;
  handleButtons: {
    icon: ElementType;
    onClick: () => void;
    title: string;
    loading?: boolean;
    onMouseEnter?: () => void;
  }[];
  searchBar?: ReactNode;
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between pb-4 border-b border-gray-200 mb-6 gap-4">
      <div className="flex flex-col gap-0.5">
        <h1 className="m-0 text-xl font-semibold text-gray-900 leading-7">
          {title}
        </h1>
        {subText && (
          <p className="m-0 text-sm text-gray-400 leading-5">{subText}</p>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-3 w-full md:w-auto justify-start md:justify-end">
        {searchBar && (
          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            {searchBar}
          </div>
        )}
        <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto justify-start sm:justify-end">
          {handleButtons.map((button, index) => (
            <Button
              key={`${button.title}-${index}`}
              size={APP_BUTTON_SIZE}
              icon={<button.icon />}
              onClick={button.onClick}
              loading={button.loading}
              onMouseEnter={button.onMouseEnter}
              className="flex-1 sm:flex-initial h-9 text-xs font-medium rounded-md"
            >
              {button.title}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
